import React, { useEffect, useState } from "react";
import Filter from "../../../../assets/Icons/filter.png";
import ExcelExport from "../../../../compnenets/commons/xls";
import Modal from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../archival.css";
import { PROJECT_ARCHIVAL } from "../../../../services/apiCalls/archivalApiCalls";

export default function DprRecord({ project }) {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const [riskData, setIssueData] = useState([]);
  const [filterData, setFilterData] = useState({
    ProjectID: project.project_id,
    StartDate: "",
    EndDate: "",
    Activity_Task: "",
    Risk_Due_Date: "",
    Risk_Status: "",
    Impact_Level: "",
    sortOrder: "ASC",
    sortBy: "Site Vist/Audit Date",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(riskData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = riskData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const fetchArchivalRisk = async (payload) => {
    let obj = payload;
    if (!payload) {
      obj = {
        ProjectID: project.project_id,
      };
    }
    const response = await PROJECT_ARCHIVAL.GetRisks(obj);
    if (response && response.RiskList?.length > 0) {
      setIssueData(response.RiskList);
    } else {
      setIssueData([]);
    }
  };
  useEffect(() => {
    fetchArchivalRisk();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <React.Fragment>
      <Modal open={open} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Risk Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    name="StartDate"
                    className="form-control shadow-none"
                    value={filterData.StartDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="EndDate"
                    value={filterData.EndDate}
                    className="form-control shadow-none"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Activity/Task</label>
                  <input
                    type="text"
                    name="Activity_Task"
                    value={filterData.Activity_Task}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Risk Due Date</label>
                  <input
                    type="date"
                    name="Risk_Due_Date"
                    className="form-control shadow-none"
                    value={filterData.Risk_Due_Date}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Risk Status</label>
                  <select
                    className="filter-label"
                    name="Risk_Status"
                    value={filterData.Risk_Status}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                    <option value="Open">Open</option>
                    <option value="Closed">Closed</option>
                  </select>
                </div>
                <div className="col-6">
                  <label className="filter-label">Impact Level</label>
                  <select
                    className="filter-label"
                    name="Impact_Level"
                    value={filterData.Impact_Level}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Issue</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option>ASC</option>
                <option>DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Role"
              value="option1"
            />
            <label for="Role" style={{ fontSize: 14 }}>
              Impact level
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Type"
              value="option1"
            />
            <label for="Type" style={{ fontSize: 14 }}>
              Priority Level
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Created"
              value="option1"
            />
            <label for="Created" style={{ fontSize: 14 }}>
              Created date
            </label>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              fetchArchivalRisk(filterData);
              setOpen(false);
              setCurrentPage(1);
            }}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport data={riskData} fileName="Risks" sheet="Risks List" />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto" onClick={() => fetchArchivalRisk()}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-archival">
        <table id="custom-table-archival">
          <thead className="table-header-archival">
            <tr>
              <th>Sr No</th>
              <th>Project Name</th>
              <th>Project Categroy</th>
              <th>Location</th>
              <th>Activity/Task</th>
              <th>Work Package</th>
              <th>Risk Description</th>
              <th>Risk Due Date</th>
              <th>Impact Level</th>
              <th style={{ whiteSpace: "nowrap" }}>Impact Description</th>
              <th>Risk Score</th>
              <th>Probability</th>
              <th>Risk Status</th>
              <th>Migration Strategy</th>
              <th>Assigned Person</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>
                  <td>{index + 1 + (currentPage - 1) * 10}</td>
                </td>
                <td>{row.ProjectName}</td>
                <td>{row.ProductCategory}</td>
                <td>{row.Location}</td>
                <td>{row.ActivityTask}</td>
                <td>workpackage name</td>
                <td>{row.RiskDescription}</td>
                <td>{row.RiskDueDate}</td>
                <td style={{ whiteSpace: "nowrap" }}>{row.ImpactLevel}</td>
                <td>{row.ImpactDescription}</td>
                <td>{row.RiskScore}</td>
                <td>{row.Probability}</td>
                <td>{row.RiskStatus}</td>
                <td>{row.MitigationStrategy}</td>
                <td>{row.AssignedPersonEmail}</td>
                <td>{new Date(row?.CreateOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min((currentPage - 1) * rowsPerPage + 1, riskData.length)} to{" "}
          {Math.min(currentPage * rowsPerPage, riskData.length)} of{" "}
          {riskData.length} entries
        </div>

        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>

          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
